// removed by extract-text-webpack-plugin
module.exports = {"Base":"InstagramPhoto__Base-7eHD9","Link":"InstagramPhoto__Link-THFAe","Article":"InstagramPhoto__Article-FBgDU","Photo":"InstagramPhoto__Photo-1HMsF"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InstagramPhoto/InstagramPhoto.css
 ** module id = 631
 ** module chunks = 0
 **/